import { render, staticRenderFns } from "./guided-tour-card.vue?vue&type=template&id=3afe7900&scoped=true&"
import script from "./guided-tour-card.vue?vue&type=script&lang=js&"
export * from "./guided-tour-card.vue?vue&type=script&lang=js&"
import style0 from "./guided-tour-card.vue?vue&type=style&index=0&id=3afe7900&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe7900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afe7900')) {
      api.createRecord('3afe7900', component.options)
    } else {
      api.reload('3afe7900', component.options)
    }
    module.hot.accept("./guided-tour-card.vue?vue&type=template&id=3afe7900&scoped=true&", function () {
      api.rerender('3afe7900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/guided-tour/guided-tour-card.vue"
export default component.exports